import { render } from "./ComboTipoDocumento.vue?vue&type=template&id=2518b209&ts=true"
import script from "./ComboTipoDocumento.vue?vue&type=script&lang=ts"
export * from "./ComboTipoDocumento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__